import React, { useState } from 'react';
import DataVisualizationView from '../../components/common/DataVisualizationView';
import Table from '../../components/common/Table/Table';
import { tables } from '../../constants';
import FilterComponent from '../../components/common/Filter';

/**
 * Water Changes Component
 *
 * This component is part of the data visualization stucture and is specifically
 * designed to handle the "Water Changes" data. It currently renders a table to
 * display the data but will support graph visualizations in the future.
 *
 * Reponsabilities:
 * - Define how the "Water Changes" data is presented.
 * - Render the appropiate components (e.g., Table, Graphs) for this data type.
 *
 * Future enhancements:
 * - Integration of graphs to complement or replace the table for better data insights.
 *
 * @returns {JSX.Element}
 */
const WaterChanges = () => {
  const [filterValues, setFilterValues] = useState({ event_id: '', metric_id: '' });
  const filterParams = { metric_id: filterValues.event_id };
  const areFiltersActive = Boolean(filterParams.metric_id);

  const handleApplyFilter = (newFilters) => {
    setFilterValues(newFilters);
  };

  const handleClearFilter = () => {
    setFilterValues({ event_id: '', metric_id: '' });
  };

  return (
    <DataVisualizationView
      dataType={tables.waterChanges}
      filterComponent={
        <FilterComponent
          onApplyFilter={handleApplyFilter}
          onClearFilter={handleClearFilter}
          initialFilterValues={filterValues}
          isFilterLoading={false}
        />
      }
      filterParams={filterParams}
      areFiltersActive={areFiltersActive}
    >
      {({ currentRecords, columns }) => {
        return <Table columns={columns} data={currentRecords} />;
      }}
    </DataVisualizationView>
  );
};

export default WaterChanges;
